module.exports = __webpack_public_path__ + "img/blur3.bc844f28.webp";